import call from './httpClient';

const BASE_URL = `${import.meta.env.VITE_APP_API_URL}/v1/orders`;

export const Get = async (id) => call({
  method: 'GET',
  url: `${BASE_URL}/${id}/invoice`,
});

export const Download = async (url) => call({
  data: {
    url,
  },
  responseType: 'blob',
  method: 'POST',
  url: import.meta.env.VITE_APP_INVOICE_API_URL,
});
